import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScannerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"scanner"}/>
}
